import React, { Component } from 'react';
import Select from 'react-select';
import { fromJS } from 'immutable';

class ComboboxInput extends Component {

    handleValueChanged(value){
        if(value !== null){
            this.props.onChange(this.props.field, value.value, value.label)
        }else{
            this.props.onChange(this.props.field, null, "")
        }
        
    }

    render() {
        var disabled = false;
        if (this.props.disabled !== null && this.props.disabled !== undefined) {
            disabled = this.props.disabled
        }

        var opt = []
        const { options, value } = this.props;
        var objValue = null
        // eslint-disable-next-line array-callback-return
        const fieldLabel = options.get('label');
        const fieldValue = options.get('value');
        // options.get('source').map((item) => {
        //     var obj = { label: item.get(fieldLabel), value: item.get(fieldValue) };
        //     opt.push(obj)
        //     if (item.get(fieldValue) == value) {
        //         objValue = obj;
        //     }
        // })

        var temp = options.get('source').toJS();
        for (var key in temp) {
            // check if the property/key is defined in the object itself, not in parent
            if (temp.hasOwnProperty(key)) {
                var item = fromJS(temp[key])
                var obj = { label: item.get(fieldLabel), value: item.get(fieldValue) };
                opt.push(obj)
                if (item.get(fieldValue) === value) {
                    objValue = obj;
                }
            }
        }

        const pholder = this.props.placeholder !== undefined ? this.props.placeholder : "Select..";

        // hasError
        const extraClass = this.props.hasError ? 'is-invalid' : '';
        return (
            <Select
                className={`basic-single ${extraClass} combobox`}    
                classNamePrefix="select"
                onChange={(value) => this.handleValueChanged(value)}
                options={opt}
                placeholder={pholder}
                id={`${this.props.field}_field`}
                value={objValue}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                isDisabled={disabled}
            />
        );
    }
}

export default (ComboboxInput);
